module.exports = {"231222001":"颜河街道","231222002":"顺达街道","231222003":"兰亚街道","231222004":"正阳街道","231222101":"兰西镇","231222102":"榆林镇","231222103":"临江镇","231222104":"平山镇","231222105":"红光镇","231222106":"远大镇","231222107":"康荣镇","231222108":"燎原镇","231222202":"北安乡","231222203":"长江乡","231222204":"兰河乡","231222205":"红星乡","231222207":"长岗乡","231222210":"星火乡","231222211":"奋斗乡","231222580":"第一原种场","231222581":"第二原种场","231222582":"兰西县畜牧技术推广服务中心"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231222.json
// module id = 793
// module chunks = 0